export default __webpack_public_path__ + "static/media/illustration-chat.7a4bc56a.svg";